import EntityModel from './entity-model';

/**
 * @abstract webhook model
 */
export default class WebhookModel extends EntityModel {
    static Statuses = {
        active: 'active',
        inactive: 'inactive',
    };

    hydrate({
        method = 'POST',
        url = 'https://',
        headers = [],
        query = null,
        body = null,
        credentialHash = null,
    } = {}) {
        this.method = method;
        this.url = url;
        this.headers = headers.map(h => WebhookModel.encodeHeader(h));
        this.query = query;
        this.body = body;
        this.credentialHash = credentialHash;
    }

    getPayload() {
        return {
            method: this.method,
            url: this.url,
            headers: this.headers.map(header => WebhookModel.decodeHeader(header)),
            query: this.query,
            body: this.body,
            credentialHash: this.credentialHash,
        };
    }

    static encodeHeader({name, value, status}) {
        return {
            name,
            value,
            isActive: status === WebhookModel.Statuses.active,
        };
    }

    static decodeHeader({name, value, isActive}) {
        return {
            name,
            value,
            status: isActive ? WebhookModel.Statuses.active : WebhookModel.Statuses.inactive,
        };
    }
}
